import { FullServingAmountFragment } from "apps/web/src/types";
import { MenuItemState } from "../reducer";

interface RecipeMenuItemInitStateInput {
  id: string;
  name: string;
  imageUrl: string | null;
  servingAmounts: readonly FullServingAmountFragment[];
}

export const buildRecipeMenuItemInitState = ({ id, name, imageUrl, servingAmounts }: RecipeMenuItemInitStateInput): MenuItemState => ({
  menuItem: {
    __typename: "MenuItem",
    id,
    history: { fromCompass: false },
    name,
    servingName: "",
    description: null,
    isOneOff: false,
    servingAmounts,
    choices: [],
    imageUrl,
    suggestionCategory: null,
    defaultMaxAmount: null,
    defaultAvailableForOrder: true,
    defaultAllowSpecialRequests: true,
    isDeleted: false,
    score: null,
    foodCategory: null,
  },
  maxAmount: null,
  availableForOrder: true,
  allowSpecialRequests: true,
  edited: false,
});
